import { render, staticRenderFns } from "./UndelegateMessageDetails.vue?vue&type=template&id=3921bed2&"
import script from "./UndelegateMessageDetails.vue?vue&type=script&lang=js&"
export * from "./UndelegateMessageDetails.vue?vue&type=script&lang=js&"
import style0 from "./UndelegateMessageDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports